import { createAsyncThunk } from '@reduxjs/toolkit';

import { MeasurementService } from '../../services';

export const createMeasurement = createAsyncThunk(
  'measurement/createMeasurement',
  async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await MeasurementService.createMeasurement(data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create measurement');
    }
  }
);

export const createMeasurements = createAsyncThunk(
  'measurement/createMeasurements',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await MeasurementService.createMeasurements(data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create measurements');
    }
  }
);

export const updateMeasurement = createAsyncThunk(
  'measurement/updateMeasurement',
  async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await MeasurementService.updateMeasurement(id, data);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to update measurements');
    }
  }
);

export const deleteMeasurements = createAsyncThunk(
  'measurement/deleteMeasurements',
  async (ids, { rejectWithValue }) => {
    try {
      await MeasurementService.deleteMeasurements(ids);

      return ids;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete measurements');
    }
  }
);

export const fetchMeasurements = createAsyncThunk(
  'measurement/fetchMeasurements',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await MeasurementService.fetchMeasurements(params);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch measurements');
    }
  }
);

export const fetchAnimalMeasurements = createAsyncThunk(
  'measurement/fetchAnimalMeasurements',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const { data } = await MeasurementService.fetchAnimalMeasurements(id, params);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch animal measurements');
    }
  }
);

export const fetchMeasurementTypes = createAsyncThunk(
  'measurement/fetchMeasurementTypes',
  async (params, { rejectWithValue }) => {
    try {
      const response = await MeasurementService.fetchMeasurementTypes(params);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch measurement types');
    }
  }
);
